import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import HomeCards from '../components/HomeCards';
import TanitimSection from '../components/TanitimSection';
import EtkinliklerCarousel from '../components/EtkinliklerCarousel';

const Home = () => {
  const navigate = useNavigate();
  return (
    <>
      <HeroSection
        backgroundImage="/imgHome1.jpeg"
        title="2025 Mezuniyetine Hazır mısınız?"
        subtitle="Gelişim Koleji ile geleceğe adım atın"
      >
        <button  onClick={() => navigate('/contact')} className="bg-[#a03838] hover:bg-[#5c0000] text-white px-6 py-3 rounded-full font-semibold transition">
          Bilgi Al
        </button>
      </HeroSection>

      <HomeCards />
      <TanitimSection />
      <EtkinliklerCarousel />
    </>
  );
};

export default Home;
